import RichUpdatesTimelineItem from './RichUpdatesTimelineItem';

export default RichUpdatesTimelineItem;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesTimelineItem/index.tsx